import cn from 'classnames';
import { Link } from '@framework/router/Next/Link';
import TruncateText from '@creditflowresearch/uilib/TruncateText';
import { IColumn } from '@creditflowresearch/uilib/Table/DataTable/interfaces/Column';
import { TagsCell } from '@/creditflowresearch/ui/common/components/TableCells';
import DateCell from './DateCell';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';
import textStyles from '@creditflowresearch/uilib/styles/helpers/text.module.scss';

const columns: IColumn[] = [
  {
    title: 'Name',
    name: 'name',
    cellCallback: ({ row, cellData }) => (
      <TruncateText value={ cellData }>
        <Link to={ row.url } target="_blank">
          { cellData }
        </Link>
      </TruncateText>
    ),
  },
  {
    title: 'Categories',
    name: 'categoriesNames',
    maxWidth: 250,
    className: cn(alignStyles.alignRight, textStyles.nowrap),
    cellCallback: TagsCell,
  },
  {
    title: 'Date',
    name: 'updatedAt',
    width: 113,
    maxWidth: 113,
    className: cn(alignStyles.alignRight, textStyles.nowrap),
    cellCallback: (cellProps) => <DateCell row={ cellProps.row } />,
  },
];

export default columns;
